import { Body1, Card, Divider, Title1 } from "@fluentui/react-components";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelSincronizarRazon } from "./UsePanelSincronizarRazon";
import { Spinner } from "@fluentui/react";
import { IRazonBaseSync, IRazonSync } from "../../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";

export const PanelSincronizarRazon=(props:IOpenPanel)=>{
   const usePanel = UsePanelSincronizarRazon(props)
   const onRenderFooter = useCallback(
    () => (
      <>
        {(usePanel.razonesSync.razonesInsertar.length!=0 || 
        usePanel.razonesSync.razonesEliminar.length!=0 || usePanel.razonesSync.razonesIntegrar.length!=0) &&(
        <PanelFooter
          texto="Guardar"
          texto2={"Salir"}
          //disableButton={disableForm}
          onClick={usePanel.SyncronizarRazones}
          onDismiss={usePanel.reset}
        />)}
      </>
    ),
    [usePanel.razonesSync]
  );
  return(
    <PanelDrawer isOpen={props.isOpen} onDismiss={usePanel.reset} 
    onRenderFooter={onRenderFooter}
    textHeader={"Razones Encontradas a Sincronizar"} status={usePanel.status} mensaje={usePanel.mensaje} 
    loading={usePanel.loading}>
        <br/>
        {!usePanel.LoadingSincronizar ? (<>
        {usePanel.razonesSync.razonesInsertar.length==0?(<Body1>
            Por el Momento, todas las razones ya han sido insertadas
        </Body1>):(
            <>
            {usePanel.razonesSync.razonesInsertar.map((item:IRazonSync,index:number)=>(
               <Card>
               <Title1>{item.codigo}-{item.descripción}</Title1>
               <Body1>Estado: {item.estado}</Body1>
               <Body1>Categoria: {item.categoriaTiempo}</Body1>
               {item.equipoModelos.length!=0 && (<>
               <Body1>Equipos Modelos:</Body1>
               {item.equipoModelos.map((item:string,index:number)=>(
                <Body1>{item}</Body1>
               ))}</>)}
               </Card>
            )
            )}
            </>
        )}
        <br/>
        <Divider/>
        <br/>
        {usePanel.razonesSync.razonesEliminar.length==0?(<Body1>
            Por el Momento, no hay razones para eliminar
        </Body1>):(
            <>
            {usePanel.razonesSync.razonesEliminar.map((item:IRazonBaseSync,index:number)=>(
               <Card>
               <Title1>{item.codigo}-{item.descripción}</Title1>
               </Card>
            )
            )}
            </>
        )}
         <br/>
         <Divider/>
         <br/>
         {usePanel.razonesSync.razonesIntegrar.length==0?(<Body1>
            Por el Momento, no hay razones para integrar
        </Body1>):(
            <>
            {usePanel.razonesSync.razonesIntegrar.map((item:IRazonBaseSync,index:number)=>(
               <Card>
               <Title1>{item.codigo}-{item.descripción}</Title1>
               </Card>
            )
            )}
            </>
        )}
        </>):(<Spinner></Spinner>)}
    </PanelDrawer>
  )
}